import * as constantes from "../constants/constantes.js";
const ENDPOINT = constantes.URLAPI;
//const ENDPOINTTEST = constantes.URL_TESTBLIBLIOTECA;

export const ListarBibliotecasPorCurso = async({jwt,idCurso})=> {
    return await fetch(`${ENDPOINT}/ZADBiblioteca/ListarBibliotecasPorCurso/${idCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/ListarBibliotecasPorCurso/${idCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}
